import dayjs, { Dayjs } from "dayjs";
import i18next from "i18next";
import { isValidDate as isValidDateString, isValidISODateString } from "iso-datestring-validator";
import { IsoDateString, IsoDateTimeString } from "../types/dateTime";
import "dayjs/locale/fi";
import "dayjs/locale/en";

export type SupportedDateFormats =
	| "L" // 08/16/2018
	| "LT" // 8:02 PM
	| "LTS" // 8:02:18 PM
	| "LL" // August 16, 2018
	| "LLL" // August 16, 2018 8:02 PM
	| "LLLL" // Thursday, August 16, 2018 8:02 PM
	| "l" // 8/16/2018
	| "ll" // Aug 16, 2018
	| "lll" // Aug 16, 2018 8:02 PM
	| "llll" // Thu, Aug 16, 2018 8:02 PM
	| "L LT";

export const formatDayJs = (
	value: Dayjs | undefined | null,
	format: SupportedDateFormats = "L",
): string => {
	if (value === undefined || value === null) return "-";
	return value.locale(i18next.language).format(format);
};

export const formatIsoString = (
	value: IsoDateTimeString | undefined | null,
	format: SupportedDateFormats = "L",
): string => {
	if (value === undefined || value === null) return "-";
	return formatDayJs(dayjs(value), format);
};

export const isValidISOString = (value: string | null | undefined): boolean => {
	if (value === null || value === undefined) {
		return false;
	} else {
		return isValidISODateString(value);
	}
};

export const isValidLocalDateTimeString = (value: string): boolean => {
	return dayjs(value, "YYYY-MM-DDThh:mm", true).isValid();
};

export const dayJsToDateIsoString = (dayJs: Dayjs): IsoDateString => dayJs.format("YYYY-MM-DD");

export const dayJsToDateIsoStringNullable = (dayJs: Dayjs | null): IsoDateString | null => {
	if (dayJs == null) return null;
	return dayJsToDateIsoString(dayJs);
};

export const formatDate = formatIsoString;

export const isValidDate = (d: any): d is Date => {
	return d instanceof Date && !isNaN(d.valueOf());
};

export const currentLocalDateAsString = (): string => {
	return dayJsToDateIsoString(dayjs().local());
};

export { isValidDateString };
